module.exports = __webpack_public_path__ + "static/media/rentIcon.4dc3fec4.svg";